<template>
  <div>
    <div class="detailsTitle">
      <h4>结算单详情</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
    <div class="addressBox">
      <h4 class="title">
        <span>
          <i class="fa fa-envelope iconFont" aria-hidden="true"></i
          >基本信息
        </span>
      </h4>
      <div class="tongJi">
        <div>
          <span>一级货主：</span>
          <span>{{dataObj.primaryCustomerName}}</span>
        </div>
        <div style="margin-left:5%;">
          <span>二级货主：</span>
          <span>{{dataObj.customerName}}</span>
        </div>
      </div>
      <div class="tongJi">
        <div>
          <span>结算单号：</span>
          <span>{{dataObj.settleNo}}</span>
        </div>
        <div style="margin-left:5%;">
          <span>结算开始时间（含）：</span>
          <span>{{dataObj.settleStartTime}}</span>
        </div>
        <div style="margin-left:5%;">
          <span>结算结束时间（含）：</span>
          <span>{{dataObj.settleEndTime}}</span>
        </div>
      </div>
    </div>
    <div class="addressBox">
      <h4 class="title">
        <span>
          <i class="fa fa-yen iconFont" aria-hidden="true"></i
          >费用明细
        </span>
      </h4>
      <div style="font-size:15px;margin:0 0 10px 30px;">
        <span>总金额：<span style="color:red;">{{dataObj.planCharge}}</span>&nbsp;元</span>
      </div>
      <div class="tongJi" style="width:600px;">
        <el-table
          ref="table"
          size="mini"
          :data="tabData"
          style="width:100%;"
          :header-cell-style="{background:'#fff',color:''}"
          border
        >
          <el-table-column prop="" label="操作" align="center" >
            <template v-slot="scope">
              <el-button type="text" @click="seeDetails(scope.row)" size="mini">查看明细</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="chargeName" label="费目名称" align="center" ></el-table-column>
          <el-table-column prop="weight" label="重量（吨）" align="center" ></el-table-column>
          <el-table-column prop="charge" label="金额（元）" align="center" ></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="addressBox">
      <h4 class="title">
        <span>
          <i class="fa fa-envelope iconFont" aria-hidden="true"></i
          >记录信息
        </span>
      </h4>
      <div class="tongJi">
        <div>
          <span>创建人：</span>
          <span>{{dataObj.createUser}}</span>
        </div>
        <div style="margin-left:5%;">
          <span>创建时间：</span>
          <span>{{dataObj.createTime}}</span>
        </div>
      </div>
      <div class="tongJi">
        <div>
          <span>作废人：</span>
          <span>{{dataObj.cancellationUser}}</span>
        </div>
        <div style="margin-left:5%;">
          <span>作废时间：</span>
          <span>{{dataObj.cancellationTime}}</span>
        </div>
      </div>
      <div class="tongJi">
        <div>
          <span>作废原因：</span>
          <span>{{dataObj.cancellationReason}}</span>
        </div>
      </div>
    </div>
    <el-dialog
        :title="XQTitle"
        :visible.sync="XQVisible"
        :close-on-click-modal="false"
        width="90%"
        center
        @close="closeXQDialog"
      >
      <el-form :model="XQData" :inline="true" ref="XQData" label-width="100px">
        <!-- <el-form-item prop="jieSuanType" label="结算方式" v-if="!CQShow">
          <el-select v-model="XQData.jieSuanType" size="mini" placeholder="请选择" filterable clearable>
            <el-option v-for="(item, index) in jieSuanTypeData" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item v-if="!CQShow">
          <el-button type="primary" @click="chaXun" size="mini" >查询</el-button>
          <el-button type="primary" @click="chongZhi" size="mini">重置</el-button>
        </el-form-item> -->
         <el-form-item>
          <el-button type="primary" @click="daoChu" size="mini">导出</el-button>
        </el-form-item>
        <el-form-item>
          <span>
            合计：<span style="color:red;">{{totalWeight}}</span>&nbsp;吨&nbsp;/
            <span style="color:red;">{{totalCharge}}</span>&nbsp;元
          </span>
        </el-form-item>
      </el-form>
      <div v-if="ZXShow">
        <el-table
            ref="tableDataZX"
            size="mini"
            :data="tableDataZX"
            style="width:100%;"
            :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            border
          >
            <el-table-column prop="settleNo" label="结算单号" align="center" width="230"></el-table-column>
            <el-table-column prop="arrivalMethod" label="到货方式" align="center" width="100"></el-table-column>
            <el-table-column prop="productTypeName" label="货物类型" align="center" width="120"></el-table-column>
            <el-table-column prop="specification" label="规格" align="center" width="150"></el-table-column>
            <el-table-column prop="model" label="材质" align="center" width="120"></el-table-column>
            <el-table-column prop="steelMillName" label="产地" align="center" width="120"></el-table-column>
            <el-table-column prop="warehouseName" label="仓位" align="center" width="120"></el-table-column>
            <el-table-column prop="allWeight" label="重量(吨)" align="center" width="100"></el-table-column>
            <el-table-column prop="price" label="单价(元/吨)" align="center" width="120"></el-table-column>
            <el-table-column prop="charge" label="金额(元)" align="center" width="120"></el-table-column>
            <el-table-column prop="instockNo" label="入库单号" align="center" width="230"></el-table-column>
            <el-table-column prop="plateNumber" label="入库车船号" align="center" width="150"></el-table-column>
            <el-table-column prop="instockPlateNumber" label="入库车号" align="center" width="150"></el-table-column>
            <el-table-column prop="instockDate" label="入库日期" align="center" width="180" ></el-table-column>
            <el-table-column prop="settleStartTime" label="计费开始日期" align="center" width="130" :formatter="dateFormat"></el-table-column>
            <el-table-column prop="settleEndTime" label="计费结束日期" align="center" width="130" :formatter="dateFormat"></el-table-column>
            <!-- <el-table-column prop="changeNo" label="转货单号" align="center" width="180"></el-table-column> -->
            <!-- <el-table-column prop="changeDate" label="转货日期" align="center" width="180"></el-table-column> -->
            <!-- <el-table-column prop="newPrimaryCustomerName" label="转货后一级货主" align="center" width="210"></el-table-column> -->
            <!-- <el-table-column prop="newSecondaryCustomerName" label="转货后二级货主" align="center" width="210"></el-table-column> -->
            <!-- <el-table-column prop="primaryCustomerName" label="入库一级货主" align="center" width="210"></el-table-column> -->
            <!-- <el-table-column prop="customerName" label="入库二级货主" align="center" width="210"></el-table-column> -->
          </el-table>
          <div class="pags" >
            <el-pagination
              background
              @current-change="handleCurrentChangeA"
              :current-page="pageInfoA.pageNo"
              :page-size="pageInfoA.pageSize"
              :page-sizes="[10,20,30,40,50]"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChangeA"
              :total="totalA"
            ></el-pagination>
          </div>
        </div>
        <div v-if="CQShow">
        <el-table
            ref="table"
            size="mini"
            :data="tableDataCQ"
            style="width:100%;"
            :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            border
          >
            <el-table-column prop="settleNo" label="结算单号" align="center" width="230"></el-table-column>
            <el-table-column prop="productTypeName" label="货物类型" align="center" width="120"></el-table-column>
            <el-table-column prop="specification" label="规格" align="center" width="150"></el-table-column>
            <el-table-column prop="model" label="材质" align="center" width="120"></el-table-column>
            <el-table-column prop="steelMillName" label="产地" align="center" width="120"></el-table-column>
            <el-table-column prop="doorFlag" label="仓库类型" align="center" width="120">
              <!-- <template slot-scope="scope"><div>
                <span v-if="scope.row.doorFlag == '2'">室外</span>
                <span v-if="scope.row.doorFlag == '1'">室内</span>
              </div></template> -->
            </el-table-column>
            <el-table-column prop="warehouseName" label="仓位" align="center" width="100"></el-table-column>
            <el-table-column prop="allWeight" label="重量(吨)" align="center" width="100"></el-table-column>
            <el-table-column prop="price" label="单价(元/吨天)" align="center" width="120"></el-table-column>
            <el-table-column prop="charge" label="金额(元)" align="center" width="120"></el-table-column>
            <el-table-column prop="chargeDay" label="计费天数" align="center" width="90"></el-table-column>
            <el-table-column prop="businessType" label="库存状态" align="center" width="100">
              <!-- <template slot-scope="scope"><div>
                <span v-if="scope.row.businessType == '1'">在库</span>
                <span v-if="scope.row.businessType == '2'">出库</span>
                <span v-if="scope.row.businessType == '3'">转出</span>
              </div></template> -->
            </el-table-column>
            <el-table-column prop="instockNo" label="入库单号" align="center" width="230"></el-table-column>
            <el-table-column prop="plateNumber" label="入库车船号" align="center" width="150"></el-table-column>
            <el-table-column prop="instockPlateNumber" label="入库车号" align="center" width="120"></el-table-column>
            <el-table-column prop="instockDate" label="入库日期" align="center" width="180" ></el-table-column>
            <el-table-column prop="outstockDate" label="出库日期" align="center" width="180" ></el-table-column>
            <el-table-column prop="settleStartTime" label="计费开始日期" align="center" width="130" :formatter="dateFormat"></el-table-column>
            <el-table-column prop="settleEndTime" label="计费结束日期" align="center" width="130" :formatter="dateFormat"></el-table-column>
            <el-table-column prop="outBillNo" label="出库货主单号" align="center" width="180"></el-table-column>
            <el-table-column prop="outStockNo" label="出库单号" align="center" width="230"></el-table-column>
            <el-table-column prop="outstockPlateNumber" label="出库车号" align="center" width="120"></el-table-column>
            <el-table-column prop="changeNo" label="转货单号" align="center" width="230"></el-table-column>
            <el-table-column prop="changeDate" label="转货日期" align="center" width="210"></el-table-column>
            <el-table-column prop="oldPrimaryCustomerName" label="原一级货主" align="center" width="210"></el-table-column>
            <el-table-column prop="oldSecondaryCustomerName" label="原二级货主" align="center" width="210"></el-table-column>
          </el-table>
          <div class="pags" >
            <el-pagination
              background
              @current-change="handleCurrentChangeB"
              :current-page="pageInfoB.pageNo"
              :page-size="pageInfoB.pageSize"
              :page-sizes="[10,20,30,40,50]"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChangeB"
              :total="totalB"
            ></el-pagination>
          </div>
        </div>
        <div v-if="ZHShow">
        <el-table
            ref="tableDataZH"
            size="mini"
            :data="tableDataZH"
            style="width:100%;"
            :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            border
          >
            <el-table-column prop="settleNo" label="结算单号" align="center" width="230"></el-table-column>
            <el-table-column prop="changeNo" label="转货单号" align="center" width="230"></el-table-column>
            <el-table-column prop="oldPrimaryCustomerName" label="原一级货主" align="center" width="210"></el-table-column>
            <el-table-column prop="oldSecondaryCustomerName" label="原二级货主" align="center" width="210"></el-table-column>
            <el-table-column prop="newPrimaryCustomerName" label="现一级货主" align="center" width="210"></el-table-column>
            <el-table-column prop="newSecondaryCustomerName" label="现二级货主" align="center" width="210"></el-table-column>
            <el-table-column prop="changeDate" label="转货时间" align="center" width="180"></el-table-column>
            <el-table-column prop="changeFeePayer" label="转货付费方" align="center" width="120">
              <!-- <template slot-scope="scope"><div>
                <span v-if="scope.row.changeFeePayer == '0'">新货主</span>
                <span v-if="scope.row.changeFeePayer == '1'">旧货主</span>
              </div></template> -->
            </el-table-column>
            <el-table-column prop="productTypeName" label="货物类型" align="center" width="120"></el-table-column>
            <el-table-column prop="specification" label="规格" align="center" width="150"></el-table-column>
            <el-table-column prop="model" label="材质" align="center" width="120"></el-table-column>
            <el-table-column prop="steelMillName" label="产地" align="center" width="120"></el-table-column>
            <el-table-column prop="number" label="件数" align="center" width="120"></el-table-column>
            <el-table-column prop="allWeight" label="转货重量(吨)" align="center" width="180"></el-table-column>
            <el-table-column prop="price" label="单价(元/吨)" align="center" width="120"></el-table-column>
            <el-table-column prop="charge" label="金额(元)" align="center" width="120"></el-table-column>
            <el-table-column prop="warehouseName" label="仓位" align="center" width="120"></el-table-column>
            <el-table-column prop="plateNumber" label="入库车船号" align="center" width="150"></el-table-column>
            <!-- <el-table-column prop="name" label="入库车号" align="center" width="150"></el-table-column> -->
            <el-table-column prop="shipForecastNo" label="入库预报编号" align="center" width="180"></el-table-column>
          </el-table>
          <div class="pags" >
            <el-pagination
              background
              @current-change="handleCurrentChangeC"
              :current-page="pageInfoC.pageNo"
              :page-size="pageInfoC.pageSize"
              :page-sizes="[10,20,30,40,50]"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChangeC"
              :total="totalC"
            ></el-pagination>
          </div>
        </div>
      <div style="width: 70px; margin: 15px auto">
        <el-button size="mini" @click="closeXQDialog">关闭</el-button>
        <!-- <el-button size="mini" type="primary" @click="addJZDialog" :loading="JZLoading">保存</el-button> -->
      </div>
      </el-dialog>
  </div>
</template>

<script>
import { getTEmptySettleInfo, getChargeInfoListBySettleInfo, getLoadingChargeDetailList, getOverdueChargeDetailList, getTransferChargeDetailList } from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { dateTimeFormat, dateFormat, dateTimeFormat1 } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      dateTimeFormat1: dateTimeFormat1,
      tableData: [],
      tabData: [],
      tableDataCQ: [],
      tableDataZX: [],
      tableDataZH: [],
      XQTitle: '',
      XQVisible: false,
      XQData: {
        jieSuanType: ''
      },
      jieSuanTypeData: [{
        label: '全部',
        value: ''
      }, {
        label: '现结',
        value: '1'
      }, {
        label: '月结',
        value: '2'
      }],
      ZXShow: false,
      CQShow: false,
      ZHShow: false,
      settleInfoId: '',
      dataObj: {},
      pageInfoA: {
        pageNo: 1,
        pageSize: 10
      },
      totalA: 0,
      pageInfoB: {
        pageNo: 1,
        pageSize: 10
      },
      totalB: 0,
      pageInfoC: {
        pageNo: 1,
        pageSize: 10
      },
      totalC: 0,
      chargeInfoId: '',
      totalWeight: 0,
      totalCharge: 0
    }
  },
  created () {
    this.settleInfoId = this.$route.query.settleInfoId
    this.getTEmptySettleInfo()
    this.getChargeInfoListBySettleInfo()
  },
  methods: {
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    timeStamp2: function (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    getTEmptySettleInfo () {
      getTEmptySettleInfo({
        settleInfoId: this.settleInfoId
      }).then((res) => {
        this.dataObj = res
        this.dataObj.settleStartTime = this.timeStamp(this.dataObj.settleStartTime)
        this.dataObj.settleEndTime = this.timeStamp(this.dataObj.settleEndTime)
        if (this.dataObj.cancellationTime) {
          this.dataObj.cancellationTime = this.timeStamp2(this.dataObj.cancellationTime)
        }
        this.dataObj.createTime = this.timeStamp2(this.dataObj.createTime)
      })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    getChargeInfoListBySettleInfo () {
      getChargeInfoListBySettleInfo({
        settleInfoId: this.settleInfoId
      }).then((res) => {
        this.tabData = res
      })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    seeDetails (row) {
      this.chargeInfoId = row.chargeInfoId
      this.totalWeight = row.weight
      this.totalCharge = row.charge
      if (row.chargeType == '0') { // 装卸费
        this.XQTitle = row.chargeName + '详情'
        this.XQVisible = true
        this.ZXShow = true
        this.CQShow = false
        this.ZHShow = false
        this.getLoadingChargeDetailList()
      } else if (row.chargeType == '1') { // 超期费
        this.XQTitle = row.chargeName + '详情'
        this.XQVisible = true
        this.CQShow = true
        this.ZXShow = false
        this.ZHShow = false
        this.getOverdueChargeDetailList()
      } else if (row.chargeType == '2') { // 转货费
        this.XQTitle = row.chargeName + '详情'
        this.XQVisible = true
        this.ZHShow = true
        this.ZXShow = false
        this.CQShow = false
        this.getTransferChargeDetailList()
      }
    },
    closeXQDialog () {
      this.XQVisible = false
    },
    chaXun () {

    },
    chongZhi () {

    },
    daoChu () {
      let form = {
        chargeInfoId: this.chargeInfoId
      }
      if (this.CQShow == true) {
        exportExcel(
          this.global.wmsStockName + '/tEmptyForJanFaCharge/exportOverdueChargeDetailList',
          form,
          '超期费详情表'
        )
      } else if (this.ZXShow == true) {
        exportExcel(
          this.global.wmsStockName + '/tEmptyForJanFaCharge/exportLoadingChargeDetailList',
          form,
          '装卸费详情表'
        )
      } else if (this.ZHShow == true) {
        exportExcel(
          this.global.wmsStockName + '/tEmptyForJanFaCharge/exportTransferChargeDetailList',
          form,
          '转货费详情表'
        )
      }
    },
    // 装卸费列表查询
    getLoadingChargeDetailList () {
      getLoadingChargeDetailList({
        chargeInfoId: this.chargeInfoId,
        pageNo: this.pageInfoA.pageNo,
        pageSize: this.pageInfoA.pageSize
      }).then((res) => {
        this.tableDataZX = res.list
        this.totalA = res.total
      })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    handleSizeChangeA (val) {
      this.pageInfoA.pageSize = val
      this.getLoadingChargeDetailList()
    },
    handleCurrentChangeA (val) {
      this.pageInfoA.pageNo = val
      this.getLoadingChargeDetailList()
    },
    // 超期费列表查询
    getOverdueChargeDetailList () {
      getOverdueChargeDetailList({
        chargeInfoId: this.chargeInfoId,
        pageNo: this.pageInfoB.pageNo,
        pageSize: this.pageInfoB.pageSize
      }).then((res) => {
        this.tableDataCQ = res.list
        this.totalB = res.total
      })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    handleSizeChangeB (val) {
      this.pageInfoB.pageSize = val
      this.getOverdueChargeDetailList()
    },
    handleCurrentChangeB (val) {
      this.pageInfoB.pageNo = val
      this.getOverdueChargeDetailList()
    },
    // 转货费类表查询
    getTransferChargeDetailList () {
      getTransferChargeDetailList({
        chargeInfoId: this.chargeInfoId,
        pageNo: this.pageInfoC.pageNo,
        pageSize: this.pageInfoC.pageSize
      }).then((res) => {
        this.tableDataZH = res.list
        this.totalC = res.total
      })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    handleSizeChangeC (val) {
      this.pageInfoC.pageSize = val
      this.getTransferChargeDetailList()
    },
    handleCurrentChangeC (val) {
      this.pageInfoC.pageNo = val
      this.getTransferChargeDetailList()
    }
  },

  mounted () {
  }

}
</script>

<style lang="less" scoped>
.tongJi {
  font-size: 15px;
  display: flex;
  margin-left: 30px;
  margin-bottom: 20px;
}
/deep/.el-input__inner{
    // width:150px!important;
  }
</style>
